import { CreateMediaDto, MediaPlacementType } from '@sr/dto';
import { FormikErrors } from 'formik';
import { VALIDATION_REQUIRED_FIELD } from 'utils/form-tools';

export interface FormValues {
  name: string;
  mediaTypeId: number | '';
  placement: string;
  countryId: number | '';
  regionId: number | '';
  cityId: number | '';
}

export const toCreateMedia = (formData: FormValues): CreateMediaDto => {

  return {
    name: formData.name,
    typeId: Number(formData.mediaTypeId),
    placement: formData.placement as MediaPlacementType,
    cityId:  formData.placement === 'local' ? Number(formData.cityId) : null,
    countryId: formData.placement === 'federal' ? Number(formData.countryId) : null,
    regionId: formData.placement === 'regional' ? Number(formData.regionId) : null,
  };
};

export const emptyValues: FormValues = {
  name: '',
  mediaTypeId: '',
  placement: '',
  countryId: '',
  regionId: '',
  cityId: '',
};

export const validate = (values: FormValues) => {
  let errors: FormikErrors<FormValues> = {};

  if (!values.name)
    errors.name = VALIDATION_REQUIRED_FIELD;
  else if (values.name.length < 3)
    errors.name = 'Минимум 3 символа';
  else if (values.name.length >= 256)
    errors.name = 'Максимум 256 символов';

  if (!values.mediaTypeId)
    errors.mediaTypeId = VALIDATION_REQUIRED_FIELD;

  if (!values.placement)
    errors.placement = VALIDATION_REQUIRED_FIELD;

  // Валидация в зависимости от выбранного размещения
  if (values.placement === 'federal' && !values.countryId) {
    errors.countryId = VALIDATION_REQUIRED_FIELD;
  }

  if (values.placement === 'regional' && !values.regionId) {
    errors.regionId = VALIDATION_REQUIRED_FIELD;
  }

  if (values.placement === 'local' && !values.cityId) {
    errors.cityId = VALIDATION_REQUIRED_FIELD;
  }

  return errors;
};